import request from "../utils/request";

export async function getFollowPins({ limit, since, max }) {
  return request({
    url: "/home",
    query: {
      limit,
      since,
      max,
    },
  });
}

export async function getJobPins({ limit, since, max, job_id }) {
  return request({
    url: "/jobs/feeds",
    query: {
      limit,
      since,
      max,
      job_id,
    },
  });
}

/**
 * 查询 Feed 流折叠明细
 * https://yapi.gaoding.com/project/1536/interface/api/154101
 */
export async function getFoldDetails({ limit, feed_seq, max }) {
  return request({
    url: `/feeds/folding-details/${feed_seq}`,
    query: {
      limit,
      max,
    },
  });
}

/***
 * 查询用户最新更新的关注对象
 * https://yapi.gaoding.com/project/1536/interface/api/154085
 */
export async function getLatestFollows({ limit }) {
  return request({
    url: `/feeds/follows/latest`,
    query: {
      limit,
    },
  });
}

/***
 * 查询用户关注 Feed 流列表
 * https://yapi.gaoding.com/project/1536/interface/api/154093
 */
export async function getFollowFeeds({ limit, since, max }) {
  return request({
    url: `/feeds/list`,
    query: {
      limit,
      since,
      max,
      fields: "feeds:FEEDS",
    },
  });
}

/***
 * 新建用户关注用户分组
 * https://yapi.gaoding.com/project/1536/interface/api/171552
 */
export async function createUserFollowCollection({ title }) {
  return request({
    url: "/follow_user_collections",
    method: "POST",
    data: {
      title,
    },
  });
}

/***
 * 用户关注用户分组列表排序
 * https://yapi.gaoding.com/project/1536/interface/api/171559
 */
export async function sortUserFollowCollection({
  follow_user_collection_id,
  after,
}) {
  return request({
    url: "/follow_user_collections/sort",
    method: "POST",
    data: {
      follow_user_collection_id,
      after,
    },
  });
}

/***
 * 获取用户关注用户分组列表
 * https://yapi.gaoding.com/project/1536/interface/api/171554
 */
export async function getUserFollowCollections({ urlname, user_id }) {
  return request({
    url: `/${urlname}/follow_user_collections`,
    query: {
      user_id,
    },
  });
}

/***
 * 用户关注用户分组内添加内容
 * https://yapi.gaoding.com/project/1536/interface/api/171556
 */
/**
 * @param {{
 *   user_ids: string[];
 *   follow_user_collection_ids: string[];
 * }} query
 * @returns {Promise<*|{msg: string, err: number}|undefined>}
 */
export async function createUserFollowCollectionItem({
  user_ids,
  follow_user_collection_ids,
}) {
  return request({
    url: "/follow_user_collection_items",
    method: "POST",
    data: {
      user_ids,
      follow_user_collection_ids,
    },
  });
}

/***
 * 用户关注用户分组内删除内容
 * https://yapi.gaoding.com/project/1536/interface/api/171557
 */
export async function deleteUserFollowCollectionItem({
  user_ids,
  follow_user_collection_ids,
}) {
  return request({
    url: "/follow_user_collection_items",
    method: "DELETE",
    data: {
      user_ids,
      follow_user_collection_ids,
    },
  });
}

/***
 * 编辑单个用户所属的关注用户分组
 * https://yapi.gaoding.com/project/1536/interface/api/171580
 */
export async function editUserFollowCollectionItem({
  user_id,
  add_ids,
  remove_ids,
}) {
  return request({
    url: "/follow_user_collection_items",
    method: "PUT",
    data: {
      user_id,
      add_ids,
      remove_ids,
    },
  });
}

/***
 * 获取关注用户分组下的用户列表
 * https://yapi.gaoding.com/project/1536/interface/api/171560
 */
/**
 * @param {{
 *   follow_user_collection_id: any;
 *   max?: number;
 *   since?: number;
 *   limit?: number;
 * }} query
 * @returns {Promise<*|{msg: string, err: number}|undefined>}
 */
export async function getFollowCollectionUsers({
  follow_user_collection_id,
  max,
  since,
  limit,
}) {
  return request({
    url: `/follow_user_collections/${follow_user_collection_id}`,
    query: {
      max,
      since,
      limit,
    },
  });
}

/***
 * 编辑关注用户分组
 * https://yapi.gaoding.com/project/1536/interface/api/171561
 */
export async function editUserFollowCollection({
  follow_user_collection_id,
  title,
}) {
  return request({
    url: `/follow_user_collections/${follow_user_collection_id}`,
    method: "PUT",
    data: {
      title,
    },
  });
}

/***
 * 删除关注用户分组
 * https://yapi.gaoding.com/project/1536/interface/api/171562
 */
export async function deleteUserFollowCollection({
  follow_user_collection_id,
}) {
  return request({
    url: `/follow_user_collections/${follow_user_collection_id}`,
    method: "DELETE",
  });
}

/***
 * 新建用户关注画板分组
 * https://yapi.gaoding.com/project/1536/interface/api/171566
 */
export async function createBoardFollowCollection({ title }) {
  return request({
    url: "/follow_board_collections",
    method: "POST",
    data: {
      title,
    },
  });
}

/***
 * 用户关注画板分组列表排序
 * https://yapi.gaoding.com/project/1536/interface/api/171567
 */
export async function sortBoardFollowCollection({
  follow_board_collection_id,
  after,
}) {
  return request({
    url: "/follow_board_collections/sort",
    method: "POST",
    data: {
      follow_board_collection_id,
      after,
    },
  });
}

/***
 * 获取用户关注画板分组列表
 * https://yapi.gaoding.com/project/1536/interface/api/171568
 */
export async function getBoardFollowCollections({ urlname, board_id }) {
  return request({
    url: `/${urlname}/follow_board_collections`,
    query: {
      board_id,
    },
  });
}

/***
 * 用户关注画板分组内添加内容
 * https://yapi.gaoding.com/project/1536/interface/api/171570
 */
export async function createBoardFollowCollectionItem({
  board_ids,
  follow_board_collection_ids,
}) {
  return request({
    url: "/follow_board_collection_items",
    method: "POST",
    data: {
      board_ids,
      follow_board_collection_ids,
    },
  });
}

/***
 * 用户关注画板分组内删除内容
 * https://yapi.gaoding.com/project/1536/interface/api/171571
 */
export async function deleteBoardFollowCollectionItem({
  board_ids,
  follow_board_collection_ids,
}) {
  return request({
    url: "/follow_board_collection_items",
    method: "DELETE",
    data: {
      board_ids,
      follow_board_collection_ids,
    },
  });
}

/***
 * 编辑单个用户所属的关注用户分组
 * https://yapi.gaoding.com/project/1536/interface/api/171580
 */
export async function editBoardFollowCollectionItem({
  board_id,
  add_ids,
  remove_ids,
}) {
  return request({
    url: "/follow_board_collection_items",
    method: "PUT",
    data: {
      board_id,
      add_ids,
      remove_ids,
    },
  });
}

/***
 * 获取关注画板分组下的画板列表
 * https://yapi.gaoding.com/project/1536/interface/api/171572
 */
/**
 * @param {{
 *   follow_board_collection_id: any;
 *   max?: number;
 *   since?: number;
 *   limit?: number;
 * }} query
 * @returns {Promise<*|{msg: string, err: number}|undefined>}
 */
export async function getFollowCollectionBoards({
  follow_board_collection_id,
  max,
  since,
  limit,
}) {
  return request({
    url: `/follow_board_collections/${follow_board_collection_id}`,
    query: {
      max,
      since,
      limit,
    },
  });
}

/***
 * 编辑关注画板分组
 * https://yapi.gaoding.com/project/1536/interface/api/171573
 */
export async function editBoardFollowCollection({
  follow_board_collection_id,
  title,
}) {
  return request({
    url: `/follow_board_collections/${follow_board_collection_id}`,
    method: "PUT",
    data: {
      title,
    },
  });
}

/***
 * 删除关注画板分组
 * https://yapi.gaoding.com/project/1536/interface/api/171574
 */
export async function deleteBoardFollowCollection({
  follow_board_collection_id,
}) {
  return request({
    url: `/follow_board_collections/${follow_board_collection_id}`,
    method: "DELETE",
  });
}
